/** returns menu object
@return { Object }
*/
export const getMenu = state => {
    return state.menu
}

/** returns submenu object
@return { Object }
*/
export const getSubMenu = state => {
    return state.submenu
}
